// src/context/ThemeContext.js
import { createContext } from "react";

export const ThemeContext = createContext(null);
